import { apiFetch } from '@/lib/api';
import type { ExtractRequest, ExtractResponse } from '@/types/extractedTopic';

export async function extractTopic(req: ExtractRequest): Promise<ExtractResponse> {
  return apiFetch<ExtractResponse>('/extract-topic', {
    method: 'POST',
    body: JSON.stringify(req),
  });
}
